<template>
  <div id="my-account">
    <SfBreadcrumbs
      class="breadcrumbs desktop-only"
      :breadcrumbs="breadcrumbs"
    />
    <SfContentPages
      title="Мой аккаунт"
      :active="activePage"
      class="my-account"
      @click:change="changeActivePage"
    >
      <SfContentPage title="Профиль">
        <MyProfile
          :account="account"
          @update:personal="update"
          @update:password="changePassword"
        />
      </SfContentPage>
      <SfContentPage title="Сообщения">
        <Messages :account="account" />
      </SfContentPage>
      <SfContentPage title="Избранное">
        <Wishlist :account="account" />
      </SfContentPage>
      <SfContentPage v-if="user.roles && user.roles.some((role) => role.id === 9)" title="Новости" icon="shipping" :class="{ active: activePage === 'Новости' }">
          <ShopNews
            :account="account"
          />
        </SfContentPage>
      <SfContentPage title="Выход" />
    </SfContentPages>
  </div>
</template>
<script>
import { SfBreadcrumbs, SfContentPages } from "@storefront-ui/vue";
import MyProfile from "../../components/account/MyProfile";
import Wishlist from "../../components/account/Wishlist";
import Messages from "../../components/account/Messages";
import ShopNews from "../../components/account/ShopNews";

import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');


export default {
  name: "MyAccount",
  components: {
    SfBreadcrumbs,
    SfContentPages,
    MyProfile,
    Wishlist,
    Messages,
    ShopNews
  },
  data() {
    return {
      activePage: "Профиль",
      breadcrumbs: [
        {
          text: "Главная",
          route: {
            link: "#",
          },
        },
        {
          text: "Мой аккаунт",
          route: {
            link: "#",
          },
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      toggleLoginModal: 'TOGGLE_MODAL',
      parseUser: 'READ',
      exit: 'REMOVE'
    }),
    ...mapActions({
      update: 'update',
      changePassword: 'changePassword',
    }),
    changeActivePage(title) {
      if (title === "Выход") {
        this.exit();
        this.$router.push({ name: 'home' })
        return;
      }
      this.activePage = title;
    },
  },

  computed: {
    ...mapState({
      isLoginModalOpen: 'isOpen',
      user: 'user'
    }),

    account() {
      return {
        ...this.user,
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
#my-account {
  box-sizing: border-box;
  @include for-desktop {
    max-width: 1272px;
    padding: 0 var(--spacer-sm);
    margin: 0 auto;
  }
}
.my-account {
  @include for-mobile {
    --content-pages-sidebar-category-title-font-weight: var(
      --font-weight--normal
    );
    --content-pages-sidebar-category-title-margin: var(--spacer-sm)
      var(--spacer-sm) var(--spacer-sm) var(--spacer-base);
  }
  @include for-desktop {
    --content-pages-sidebar-category-title-margin: var(--spacer-xl) 0 0 0;
  }
}
.breadcrumbs {
  padding: var(--spacer-base) 0 var(--spacer-lg);
}
</style>